import React from 'react';
import styles from '../assets/styles/LawyerProfile.module.css';

const LawyerProfile = ({ img, name, title, bioLines }) => {
  return (
    <div>
      <div className={styles.lawyerProfile}>
        <div className={styles.imageContainer}>
          <img src={img} alt={name} className={styles.img} />
        </div>
        <div className={styles.textContent}>
          <div className={styles.details}>
            <div className={styles.name}>{name}</div>
            <div className={styles.title}>{title}</div>
          </div>
          <div className={styles.bio}>
            {bioLines.map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LawyerProfile;